/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Workshopsandtraininginformation3Inputs */

const de__field_workshopsandtraininginformation3 = /** @type {(inputs: _Field_Workshopsandtraininginformation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workshops und Schulungsinformationen`)
};

/**

* @param {_Field_Workshopsandtraininginformation3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_workshopsandtraininginformation3 = /** @type {((inputs?: _Field_Workshopsandtraininginformation3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Workshopsandtraininginformation3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_workshopsandtraininginformation3(inputs)
});
export { _field_workshopsandtraininginformation3 as "_field_workshopsAndTrainingInformation" }